import {
  RESET_UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_ERROR,
  UPDATE_CUSTOMER_LOADING,
  UPDATE_CUSTOMER_SUCCESS,
} from "../type/Constant";

let initialState = {
  error: false,
  success: false,
  loading: false,
  errors: [],
};

export default function editCustomerReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CUSTOMER_LOADING:
      return { ...state, error: false, loading: true, success: false };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        error: false,
        success: true,
        loading: false,
        message: action.msg,
      };
    case UPDATE_CUSTOMER_ERROR:
      return { ...state, error: true, success: false, loading: false };
    case RESET_UPDATE_CUSTOMER:
      return {
        ...state,
        error: false,
        success: false,
        loading: false,
        errors: [],
      };
    default:
      return state;
  }
}
